module.exports = __webpack_public_path__ + "static/img/logo.50fbae1c.svg";